import React from 'react';
import { useDragLayer } from 'react-dnd';
import DragItem from './DragItem';
import DragItemTypes from '../../constants/DragItemType';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};
function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }
  const { x } = currentOffset;
  const { y } = currentOffset;
  const transform = `translate(${x}px, ${y}px) scale(1.05)`;
  return {
    transform,
    WebkitTransform: transform,
    opacity: 0.8
  };
}

const CustomDragLayer = () => {
  const { itemType, isDragging, item, currentOffset } = useDragLayer(
    monitor => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging()
    })
  );

  function renderItem() {
    switch (itemType) {
      case DragItemTypes.MENU:
        return <DragItem name={item.name} itemType={itemType} />;
      default:
        return null;
    }
  }

  if (!isDragging) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(currentOffset)}>{renderItem()}</div>
    </div>
  );
};
export default CustomDragLayer;
